import React from 'react'
import CarouselBanner from '../../components/CarouselBanner/CarouselBanner'
import { detectDeviceType } from '../../Helpers/detectDeviceType'
import Badget from '../../components/Badgets/Badget'
import { BiCheckCircle, BiCheckShield, BiHeart, BiSolidHeart } from "react-icons/bi";
import './Home.css'
import { ProductCard } from '../Collection/Collection';

const imgs_desktop = [
  // "https://theartwolf.com/wp-content/uploads/2021/05/Van_Gogh_-_Rhone_-_1920-1080.jpg",
  // "https://firebasestorage.googleapis.com/v0/b/outletbysize.appspot.com/o/1-DESKTOP-70%25.jpg?alt=media&token=1df0bc33-f536-4fec-b37e-a8d28cbe0b8a",
  // "https://firebasestorage.googleapis.com/v0/b/outletbysize.appspot.com/o/2DESKTOP.jpg?alt=media&token=9ee8ff01-c966-4777-b238-8ce723ceebc2",
  // "https://firebasestorage.googleapis.com/v0/b/outletbysize.appspot.com/o/3-DRDKTOP.jpg?alt=media&token=e03b4716-d3c5-4369-93a5-ccedd16c6ec1",
  // "https://firebasestorage.googleapis.com/v0/b/outletbysize.appspot.com/o/4-DESKTOP.jpg?alt=media&token=db9a0fe4-37c7-43ce-ab91-7fb95d4b51c5",
  "https://firebasestorage.googleapis.com/v0/b/outletbysize.appspot.com/o/5-DESKTOP.jpg?alt=media&token=15099444-f972-4e0b-8b5e-7e3e3c5a8fe9",
]

const imgs_mobile = [
  // "https://theartwolf.com/wp-content/uploads/2021/05/Van_Gogh_-_Rhone_-_1920-1080.jpg",
  // "https://firebasestorage.googleapis.com/v0/b/outletbysize.appspot.com/o/1-MOBILE-70%25.jpg?alt=media&token=d9f3057a-fbbe-49c1-a7a3-4fa651c4f374",
  // "https://firebasestorage.googleapis.com/v0/b/outletbysize.appspot.com/o/2-MOBILE.jpg?alt=media&token=06bbe7aa-e759-437b-9160-181754beac46",
  // "https://firebasestorage.googleapis.com/v0/b/outletbysize.appspot.com/o/3-MOBILE.jpg?alt=media&token=e1dbc3b3-c8dc-48d2-8f64-3a2d7edda03f",
  // "https://firebasestorage.googleapis.com/v0/b/outletbysize.appspot.com/o/4-MOBILE.jpg?alt=media&token=94bddda2-2847-49c8-ae45-7e41b536eb2f",
  "https://firebasestorage.googleapis.com/v0/b/outletbysize.appspot.com/o/5-MOBILE.jpg?alt=media&token=d8f091df-0082-4aff-8c83-a9af75d6d7df",
]

export default function Home({product_data_for_sell, selectProductFromCollection, collection_products, cart_items, add_to_cart, remove_from_cart, loading_collection, collection_qty}) {
  const device = detectDeviceType();

  const selectProduct = async (product) => {
    await selectProductFromCollection(product)
  }

  return (
    <div className='Home'>
      <CarouselBanner imgSrcs={device === "Mobile" ? imgs_mobile : imgs_desktop} />
      <div className='Badgets'>
        <Badget Icon={BiCheckCircle} regular_text={"Satisfacción"} bold_text={"garantizada"} />
        <Badget Icon={BiCheckCircle} regular_text={"Pagos"} bold_text={"contraentrega"} />
        <Badget Icon={BiSolidHeart} regular_text={"Envios"} bold_text={"gratis"} />
      </div>
      <div className='SelectSize'>
        {
          collection_products.length > 0 && (
            <div>
              <div className='SelectSizeTitle'>Los más vendidos</div>
              <div className='SelectSizeSubTitle'>+{collection_products.length} resultados</div>
            </div>
          )
        }
      </div>

      <div className='CollectionList'>
        {
          collection_products.map(product=>
            product.comodin_title && (
              <div>
                <ProductCard selectProduct={()=>selectProduct(product)} product={product} cart_items={cart_items} add_to_cart={add_to_cart} remove_from_cart={remove_from_cart}/>
              </div>
            )
          )
        }
      </div>
    </div>
  )
}
